import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-extrabold text-foreground-950">
                日批视频
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              热门短视频平台合集，聚合最新、最有意思的短视频内容，覆盖生活、美食、音乐、游戏、搞笑等多元类别。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">分类导航</h3>
            <ul className="mt-4 space-y-2">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">快捷入口</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">首页</Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">搜索视频</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">联系我们</h3>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500"></i>
                contact@ripivideo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-primary-500"></i>
                每日 09:00 - 22:00 更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 日批视频 · 本网站内容均为演示数据</p>
          <p>热门短视频平台合集 · 聚合观看新体验</p>
        </div>
      </div>
    </footer>
  );
}